import { GTM_LIST_NAME, GtmPromotion } from 'store/googleTagManager/types';

export const getThecaPromotion = (
  productId: string,
  isInternalPromotions: boolean,
  searchPhrase = ''
): GtmPromotion => {
  const name = isInternalPromotions ? GTM_LIST_NAME.THECA_INTERNAL : GTM_LIST_NAME.THECA_EXTERNAL;

  return {
    creative_name: name,
    creative_slot: `${GTM_LIST_NAME.SEARCH_PAGE} | ${searchPhrase}`,
    promotion_id: productId,
    promotion_name: name
  };
};

export const getThecaPromotionList = (
  productIds: string[],
  isInternalPromotions: boolean,
  searchPhrase?: string
): GtmPromotion[] =>
  productIds.map(productId => getThecaPromotion(productId, isInternalPromotions, searchPhrase));
